<template lang="html">
    <div :class="`w-100 d-flex align-items-center ${justifyEnd ? 'justify-content-end' : 'justify-content-start'}`">
        <div class="card-img sw-3">
            <img :src="avatarSrc" class="rounded-circle w-100 h-100" alt="thumb" :title="fullname">
        </div>
    </div>
</template>

<script>
export default {
  name: 'ReviewConsultantBox',
  props: {
    avatarSrc: String,
    fullname: String,
    justifyEnd: {
      type: Boolean,
      required: false
    }
  }
};
</script>

